var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingPoQty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.23438,
    width: 24,
    height: 24,
    rx: 5,
    fill: "#FE9D0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5664 13.6641V15.4974L17.8997 16.3307",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5664 5.33594H18.2331C18.6751 5.33594 19.099 5.51153 19.4116 5.82409C19.7241 6.13665 19.8997 6.56058 19.8997 7.0026V7.69594",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89974 5.33594H8.23307C7.79105 5.33594 7.36712 5.51153 7.05456 5.82409C6.742 6.13665 6.56641 6.56058 6.56641 7.0026V18.6693C6.56641 19.1113 6.742 19.5352 7.05456 19.8478C7.36712 20.1603 7.79105 20.3359 8.23307 20.3359H9.89974",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5664 20.3359C19.3278 20.3359 21.5664 18.0974 21.5664 15.3359C21.5664 12.5745 19.3278 10.3359 16.5664 10.3359C13.805 10.3359 11.5664 12.5745 11.5664 15.3359C11.5664 18.0974 13.805 20.3359 16.5664 20.3359Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7357 3.66406H10.7357C10.2754 3.66406 9.90234 4.03716 9.90234 4.4974V6.16406C9.90234 6.6243 10.2754 6.9974 10.7357 6.9974H15.7357C16.1959 6.9974 16.569 6.6243 16.569 6.16406V4.4974C16.569 4.03716 16.1959 3.66406 15.7357 3.66406Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingPoQty);
export default __webpack_public_path__ + "static/media/pending_po_qty.ea0d860fb40b7734e1a54f5686afed9c.svg";
export { ForwardRef as ReactComponent };